mmf_modules.define('backbone_mmf',[
    'backbone',
    'underscore'
], function (
    Backbone,
    _
) {
    'use strict';

    Backbone.triggerMethod = (function(){

      // split the event name on the ":"
      var splitter = /(^|:)(\w)/gi;

      // take the event section ("section1:section2:section3")
      // and turn it in to uppercase name
      function getEventName(match, prefix, eventName) {
        return eventName.toUpperCase();
      }

      // actual triggerMethod implementation
      var triggerMethod = function(event) {
        // get the method name from the event name
        var methodName = 'on' + event.replace(splitter, getEventName);
        var method = this[methodName];

        // trigger the event, if a trigger method exists
        if(_.isFunction(this.trigger)) {
          this.trigger.apply(this, arguments);
        }

        // call the onMethodName if it exists
        if (_.isFunction(method)) {
          // pass all arguments, except the event name
          return method.apply(this, _.tail(arguments));
        }
      };

      return triggerMethod;
    })();

    Backbone.Controller = function(options){
      this.triggerMethod = Backbone.triggerMethod;
      this.options = options || {};

      if (_.isFunction(this.initialize)){
        this.initialize(this.options);
      }
    };

    Backbone.Controller.extend = Backbone.Model.extend;

    _.extend(Backbone.Controller.prototype, Backbone.Events, {
      close: function(){
        this.stopListening();
        this.triggerMethod("close");
        this.unbind();
      }
    });

    var sync_mixin = {
        // `preSync` is a useful hook from which events can be published,
        //      and options / model may be modified.
        preSync: function (method, model, options) {},

        // override sync to:
        //  - call preSync first
        //  - because tastypie and backbone disagree on whether delete should have trailing slash
        sync: function (method, model, options) {
            // return false from preSync to cancel sync
            var continue_with_sync = model.preSync(method, model, options);
            if (continue_with_sync === false) {
                return;
            }
            if (method.toLowerCase() === 'delete') {
                options = options || {};
                if (!options.url) {
                    options.url = _.result(model, 'url').replace(/\/$/, "") + '/';
                }
            }
            return Backbone.sync.apply(this, arguments);
        }
    };

    Backbone.Model = Backbone.Model.extend(sync_mixin);

    Backbone.Collection = Backbone.Collection.extend(sync_mixin);

    return Backbone;
});
